import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import Question from './Question'

const Questions = () => {
  const { interviewResponses, questionIndex } = usePracticeInterviewing()

  return (
    <>
      {interviewResponses.map((response, index) => {
        return (
          questionIndex === index && (
            <Question question={response} index={index} />
          )
        )
      })}
    </>
  )
}

export default Questions
